import { memo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Card, Divider, Flex, Space, Typography } from 'antd';

import { getSignUpPath } from '@/shared/constants/router';
import { useEmbeddedMode } from '@/shared/lib/hooks';
import { Link } from '@/shared/ui/link';

interface SignInCardProps {
    signInFormSlot: ReactNode;
    googleSignInButtonSlot: ReactNode;
}

export const SignInCard = memo((props: SignInCardProps) => {
    const { signInFormSlot, googleSignInButtonSlot } = props;

    const { t } = useTranslation('auth');

    const { isEmbedded } = useEmbeddedMode();

    return (
        <Card
            className="auth-card"
            title={
                <Typography.Title level={2}>
                    {t('signInCardTitle')}
                </Typography.Title>
            }
        >
            {googleSignInButtonSlot}
            <Divider plain>{t('signInCardDivider')}</Divider>
            {signInFormSlot}
            {!isEmbedded && (
                <Flex justify="center">
                    <Space size={4}>
                        <span>{t('sigInCardQuestion')}</span>
                        <Link to={getSignUpPath()}>{t('sigInCardLink')}</Link>
                    </Space>
                </Flex>
            )}
        </Card>
    );
});

SignInCard.displayName = 'SignInCard';
